import React, { useState, useEffect } from 'react';
import './ReportsList.css';
import apiService from '../../services/api';
import AMSDashboard from './AMSDashboard';
import ResourceDashboard from './ResourceDashboard';
import CSATDashboard from './CSATDashboard';
import EngagementInsightsDashboard from './EngagementInsightsDashboard';

const ReportsList = () => {
  const [surveyTypes, setSurveyTypes] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [error, setError] = useState(null);

  // Map Survey Type IDs to Survey IDs
  const surveyIdMap = {
    14: 1665, // CR-AMS type id 14 => survey id 1665
    13: 1664, // CR-Resource type id 15 => survey id 1666 (placeholder, adjust as needed)
  };

  useEffect(() => {
    const fetchSurveyTypes = async () => {
      try {
        const data = await apiService.fetchData('surveys_types');
        console.log("Survey Types Loaded:", data);

        if (Array.isArray(data.results) && data.results.length > 0) {
          setSurveyTypes(data.results);
          setActiveTab(data.results[0]); // Set first tab as active
        } else {
          setError('No survey types found.');
        }
      } catch (err) {
        console.error(err);
        setError('Failed to load survey types.');
      }
    };

    fetchSurveyTypes();
  }, []);

  const handleTabClick = (type) => {
    setActiveTab(type);
  };

  const renderDashboard = () => {
    if (!activeTab) return null;

    const surveyId = surveyIdMap[activeTab.ID];

    console.log("Active tab:", activeTab);
    console.log("Mapped Survey ID:", surveyId);

    // if (!surveyId) return <p>No dashboard configured for this survey type.</p>;

    switch (activeTab.Type) {
      case 'CR CSAT - AMS Project':
        console.log("AMS Dashboard tab selected");
        return <AMSDashboard surveyId={surveyId} />;
      case 'CR CSAT - Resource (TOD)':
        console.log("Resource Dashboard tab selected");
        return <ResourceDashboard surveyId={surveyId} />;
    }
  };

  return (
    <div className="reports-container">
      <h2 className="reports-title">Reports</h2>

      {error && <p style={{ color: 'red' }}>{error}</p>}
<div style={{ width: '100%',marginBottom: '20px' }}>
      <div className="reports-tabs-container">
        {surveyTypes.map((type) => (
          <button
            key={type.ID}
            className={`reports-tab ${activeTab?.ID === type.ID ? 'active' : ''}`}
            onClick={() => handleTabClick(type)}
            style={{ textDecoration: activeTab?.ID === type.ID ? 'underline' : 'none',border: 'none', color: '#015EBE', background: 'none' }}
          >
            {type.Type}
          </button>
        ))}
      </div>
</div>
      <div className="reports-content">
  {activeTab ? (
    <>
      {renderDashboard()}

      {/* Additional conditionally rendered dashboards */}
      {activeTab.Type?.includes('Engagement Level') ? (
        <EngagementInsightsDashboard selectedType={activeTab} />
      ) : activeTab.Type?.includes('Development Project') ? (
        <CSATDashboard selectedType={activeTab} />
      ) : null}
    </>
  ) : (
    <p>Loading or no survey type selected...</p>
  )}
</div>

    </div>
  );
};

export default ReportsList;